import { render, staticRenderFns } from "./navAside.vue?vue&type=template&id=399a3bf3&scoped=true&"
import script from "./navAside.vue?vue&type=script&lang=js&"
export * from "./navAside.vue?vue&type=script&lang=js&"
import style0 from "./navAside.vue?vue&type=style&index=0&id=399a3bf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a3bf3",
  null
  
)

export default component.exports